import * as React from 'react'

import Stack from '@mui/material/Stack'

import ResponsiveContainer from 'components/atomic/organisms/responsive-container'
import PathSyllabus from 'pages/path/syllabus/enrolled'
import ResumeContent from 'pages/path/resume-content'
import PathProgress from 'pages/path/progress'

const EnrolledPathContent = ({ pathId }: { pathId: string }) => {
    return (
        <ResponsiveContainer maxWidth="lg">
            <Stack mt="3rem" spacing="3rem">
                <ResumeContent pathId={pathId} />
                <PathProgress pathId={pathId} />
                <PathSyllabus pathId={pathId} />
            </Stack>
        </ResponsiveContainer>
    )
}

export default EnrolledPathContent
